import { NavigationHistoryStack } from 'ui-ng-navbar';

export class SurveyStepService {
  private isTransitioning: boolean;
  private requestDelegate: any;
  private currentPageNk: string;
  private pageIndex: string;
  private _activeSortType: string;
  private _sortOrder: string;
  private hasRequestedTransition: boolean = false;

  constructor(
    private myIntakeModel: any,
    private phxDelegateTagDelegate: any,
    private phxValidationFacade: any,
    private $state: ng.ui.IStateService,
    private programSortEnum: any,
    private ngNavigationHistoryStack: NavigationHistoryStack
  ) {
    this._activeSortType = 'rank';
    this._sortOrder = 'asc';
  }

  initialize(pageIndex: string): void {
    this.pageIndex = pageIndex;
    this.isTransitioning = false;
    this.currentPageNk = this.myIntakeModel.getCurrentPage().nk;
    this.requestDelegate = this.phxDelegateTagDelegate.handle(this.delegateHandle());
  }

  get currentPage() {
    return this.myIntakeModel.getCurrentPage();
  }

  get activeSortType(): string {
    return this._activeSortType;
  }

  set activeSortType(sort: string) {
    this._activeSortType = sort;
  }

  get sortOrder(): string {
    return this._sortOrder;
  }

  delegateHandle(): string {
    if (this.pageIndex === '1' && this.currentPageNk === 'EI_INTAKE_GOALS') {
      return this.currentPageNk + 'second';
    }
    const isSecondPage: boolean = this.myIntakeModel.progression.isSecondListSelectionPage();
    return this.currentPageNk === 'EI_INTAKE_INTERESTS'
      ? this.currentPageNk + (isSecondPage ? 'second' : 'first')
      : this.currentPageNk;
  }

  goToNext(): void {
    this.hasRequestedTransition = false;
    if (this.myIntakeModel.progression.isLast()) {
      this.$state.go('my.majorexplorer');
    } else {
      this.$state.go('my.majorexplorer-step', {
        pageIndex: this.myIntakeModel.progression.peekNextIndex()
      });
    }
  }

  goToPrevious(): void {
    this.hasRequestedTransition = false;
    if (this.myIntakeModel.progression.isFirst()) {
      this.ngNavigationHistoryStack.goBack();
    } else {
      this.$state.go('my.majorexplorer-step', {
        pageIndex: this.myIntakeModel.progression.peekPreviousIndex()
      });
    }
  }

  requestMoveToPrevious() {
    this.hasRequestedTransition = true;
    if (this.myIntakeModel.progression.isLast()) {
      this.goToPrevious();
    } else {
      this.requestDelegate.invoke().then(() => {
        this.goToPrevious();
      });
    }
  }

  requestMoveToNext() {
    this.hasRequestedTransition = true;
    if (!this.enableContinueButton() || this.isTransitioning) {
      return;
    }
    this.isTransitioning = true;
    return this.requestDelegate.invoke().then(() => {
      this.goToNext();
    });
  }

  activateButton(): boolean {
    return this.phxValidationFacade.areAllValid();
  }

  enableContinueButton(): boolean {
    return !this.isTransitioning && this.activateButton();
  }

  showValidationAlert(): boolean {
    return this.hasRequestedTransition && !(this.isTransitioning || this.phxValidationFacade.areAllValid());
  }

  sortPrograms(sortType: string): void {
    const newOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    this._sortOrder = this.activeSortType === sortType ? newOrder : this.programSortEnum.key(sortType).sortOrder;
    this.activeSortType = sortType;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/services/survey_step_service.ts